var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8966 4.96552V2.37931H20.3103C20.6897 2.37931 21 2.06897 21 1.68966C21 1.31034 20.6897 1 20.3103 1H1.68966C1.31034 1 1 1.31034 1 1.68966C1 2.06897 1.31034 2.37931 1.68966 2.37931H4.10345V4.89655C4.10345 6.24138 4.75862 7.51724 5.86207 8.27586L10.069 11.3448L5.93103 14.3103C4.7931 15.1379 4.10345 16.4828 4.10345 17.8966V20.8276C4.10345 20.8966 4.10345 20.931 4.13793 21H1.68966C1.31034 21 1 21.3103 1 21.6897C1 22.069 1.31034 22.3793 1.68966 22.3793H20.3103C20.6897 22.3793 21 22.069 21 21.6897C21 21.3103 20.6897 21 20.3103 21H17.8621C17.8621 20.931 17.8966 20.8966 17.8966 20.8276V17.9655C17.8966 16.5172 17.1724 15.1379 16 14.3103L11.931 11.3448L16.2069 8.27586C17.2759 7.51724 17.8966 6.24138 17.8966 4.96552ZM16.5172 17.9655V20.8276C16.5172 20.8966 16.5172 20.931 16.5517 21H5.44828C5.44828 20.931 5.48276 20.8966 5.48276 20.8276V17.8966C5.48276 16.931 5.96552 16 6.72414 15.4138L11 12.3793L15.2069 15.4483C16.0345 16 16.5172 16.9655 16.5172 17.9655ZM15.4138 7.17241L11 10.3103L6.65517 7.13793C5.93104 6.62069 5.48276 5.7931 5.48276 4.89655V2.37931H16.5172V4.96552C16.5172 5.82759 16.1034 6.65517 15.4138 7.17241Z",
    fill: "#5981e9",
    stroke: "#5981e9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnNotice);
export default __webpack_public_path__ + "static/media/on_notice.7bb4c6337ec97081fafa460e6ca9aada.svg";
export { ForwardRef as ReactComponent };